<div
  class="mb-2 field flex flex-column w-full"
  [ngClass]="options?.containerClass"
>
  <label class="mb-2" *ngIf="options.label | translate">
    {{ options.label | translate }} {{ onOffLabel }}
  </label>
  <div class="flex align-items-center">
    <p-inputSwitch
      (onChange)="onChange($event)"
      [formControlName]="options.formControlName"
      [name]="options.formControlName"
    ></p-inputSwitch>
    <div
      *ngIf="options.tooltip"
      [pTooltip]="options.tooltip || ''"
      tooltipPosition="left"
      class="bg-black-alpha-10 border-circle flex align-content-center justify-content-center p-1 mb-1 ml-2 cursor-pointer"
    >
      <i class="pi pi-info font-normal text-xs"></i>
    </div>
  </div>
  <app-field-errors [errors]="errors"></app-field-errors>
</div>
